<template>
  <div id="app">
    <Sidebar />
    <div class="main">
      <p class="side-section">WOLKVOX</p>
      <router-view />
    </div>
    <ScrollTop/>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import ScrollTop from "@/components/ScrollTop.vue";
export default {
  components: {
    Sidebar,
    ScrollTop
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap"); */

body {
  margin: 0;
  box-sizing: border-box;
  font-family: 'Raleway', sans-serif;
}
*,
*:after,
*:before {
  box-sizing: inherit;
}
.main {
  display: grid;
  grid-template-columns: 300px 1fr;
}

@media(max-width: 767px){
  .main{
    display: block;
  }
  .content-apis{
    display: block !important;
  }

  img{
    max-width: 100%;
  }

  .side-section{
    display: none;
  }
}
</style>
